import { ShieldCheck, UserCog, Search, GraduationCap } from "lucide-react";
import { ABOUT_YOUNG_SPINE, ABOUT_SIGNOFF } from "@/data/copy";
import { SpineMotif } from "@/components/brand/SpineMotif";
import { accent } from "@/lib/ui";

const POINTS = [
  { icon: ShieldCheck, title: "Non-surgical care", text: "Conservative care only — no injections and no surgery. Investigations are advised only when clinically needed." },
  { icon: UserCog, title: "Personalised plans", text: "Your plan is built around your symptoms, work, lifestyle and daily activities." },
  { icon: Search, title: "Root-cause focus", text: "We look beyond temporary relief to the factors that may be contributing to your pain." },
  { icon: GraduationCap, title: "Prevention and education", text: "Guidance on posture, movement and habits to help reduce the risk of recurring problems." },
];

export const WhyYoungSpine = () => (
  <section className="section relative overflow-hidden bg-gradient-to-b from-brand-tint via-white to-brand-warmTint/60" aria-labelledby="why-heading">
    <SpineMotif className="pointer-events-none absolute -right-2 top-10 hidden h-[480px] text-brand-green/10 md:block" count={14} />
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <p className="eyebrow">Why Young Spine</p>
        <h2 id="why-heading" className="font-heading text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">Care that looks beyond the pain</h2>
        <p className="mt-5 text-base leading-relaxed text-slate-700">{ABOUT_YOUNG_SPINE}</p>
        <p className="mt-4 font-heading text-lg font-semibold text-brand-blue">{ABOUT_SIGNOFF}</p>
      </div>
      <ul className="grid gap-4 sm:grid-cols-2 lg:col-span-7">
        {POINTS.map(({ icon: Icon, title, text }, i) => (
          <li key={title} className={`rounded-3xl bg-white p-6 ring-1 ring-slate-200/80 transition-shadow duration-300 ${accent(i).glow} ${i % 2 ? "sm:translate-y-8" : ""}`} data-testid={`why-point-${i + 1}`}>
            <span className={`flex h-11 w-11 items-center justify-center rounded-2xl shadow-md ${accent(i).icon}`}>
              <Icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-4 text-lg font-bold text-brand-ink">{title}</h3>
            <p className="mt-2 text-base leading-relaxed text-slate-600">{text}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
